import styled from "styled-components";

// Use the same color as MenuItem for borders
const BORDER_COLOR = "#09779E";

const NestedMenuContent = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  background-color: #ffffff;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  /* sticky-left */
  top: 0;
  right: 100%;
`;

const NestedMenu = styled.div`
  position: relative;
  width: 100%;
  z-index: 99999;
  
  /* Keep parent highlighted with borders when menu is open */
  ${({ isOpen }) => (isOpen ? 
    `> div:first-child { 
      border-top: 2px solid ${BORDER_COLOR}; 
      border-bottom: 2px solid ${BORDER_COLOR}; 
      background: transparent;
      padding-top: 10px;
      padding-bottom: 10px;
    }` : '')}
`;

export { NestedMenu, NestedMenuContent };
